// extracted by mini-css-extract-plugin
export default {"imageWrapper":"cF-z","hovered":"dF-z","hoverImage":"eF-z","mainImage":"fF-z","imageNoBackground":"gF-z","fullSizeImage":"hF-z"};